import * as React from 'react';

interface Props {
    onQuery: (query: string) => void;
}

interface State {
    query: string;
}

export default class Search extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            query: ''
        };
        this.onChange = this.onChange.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.doSearch = this.doSearch.bind(this);
    }

    public render(): React.ReactNode {
        return (
            <div>
                <input type="text" value={this.state.query} onChange={this.onChange} onKeyUp={this.onKeyUp} />
                <button onClick={this.onSubmit}>Search</button>
            </div>
        );
    }

    private onChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({ query: event.target.value });
    }

    private onKeyUp(event: React.KeyboardEvent<HTMLInputElement>): void {
        if (event.keyCode === 13) {
            this.doSearch();
        }
    }

    private onSubmit(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
        this.doSearch();
    }

    private doSearch(): void {
        this.props.onQuery(this.state.query);
    }
}
